import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ClientAvatar } from "@/components/ClientAvatar";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChevronRight, User as UserIcon, Briefcase } from "lucide-react";

export default function AdminNotes() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [contractors, setContractors] = useState({});

  useEffect(() => {
    api.get("/clients").then(({ data }) => setClients(data));
    api.get("/contractors").then(({ data }) => {
      const map = {};
      data.forEach((c) => (map[c.id] = c.name));
      setContractors(map);
    });
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-notes">
      <div>
        <p className="text-label">Submissions</p>
        <h1 className="font-display text-3xl font-bold tracking-tight">Daily Notes</h1>
        <p className="text-sm text-muted-foreground">Pick a client to launch the month calendar dashboard.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="notes-client-cards">
        {clients.map((c) => (
          <button
            key={c.id}
            onClick={() => navigate(`/admin/notes/${c.id}`)}
            className="text-left clinical-card p-5 hover:bg-secondary transition-colors flex items-center gap-3"
            data-testid={`notes-client-${c.id}`}
          >
            <ClientAvatar
              name={c.name}
              photoUrl={c.photo_data_url}
              className="h-12 w-12 rounded-md object-cover"
              placeholderClassName="h-12 w-12 rounded-md bg-primary/10 text-primary flex items-center justify-center font-display font-bold"
              testId={`notes-client-${c.id}-photo`}
            />
            <div className="flex-1 min-w-0">
              <p className="font-display font-bold leading-tight truncate">{c.name}</p>
              <p className="text-xs text-muted-foreground flex items-center gap-1.5">
                <Briefcase className="w-3 h-3" /> {contractors[c.contractor_id] || "—"}
              </p>
            </div>
            <ChevronRight className="w-5 h-5 text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
